export default "__VITE_ASSET__BBT4S71r__"